import Model, { attr, belongsTo, hasMany } from '@warp-drive/legacy/model';

import { buildValidations } from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({});

export const settings = {
  copyableOptions: {
    ignoreAttributes: ['scans', 'activeScan', 'hasRunningScan'],
  },
};

export default class A11yScannerModel extends Model.extend(Validations) {
  // Attributes
  @attr('string', { defaultValue: 'DE' }) country;
  @attr('string') domain;
  @attr('string') type;
  @attr('boolean') recurringScan;
  @attr('number') dayOfScan;
  @attr('string') scanInterval;
  @attr('string') urlsToScan;
  @attr('boolean') hasRunningScan;

  // Relations
  @hasMany('a11y-scan', { async: true, inverse: null }) scans;
  @belongsTo('a11y-scan', { async: true, inverse: null }) activeScan;

  // Meta fields
  @attr cmsCreated;
  @attr cmsModified;
  @attr() cmsHistory;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Getter and setter
  get displayHeadline() {
    return this.domain;
  }

  get displayLabel() {
    return this.domain;
  }
}
